<template>
  <div class="juou-card">
    <HpsfirProTable
      ref="tableRef"
      export-file-name="微信小程序管理"
      title="微信小程序管理"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :on-delete="deleteFun"
      :on-edit="updateFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :top-operates="topOperates"
      :add-init-values="addInitValue"
      :operation-width="380"
      :codition-init-values="conditionsInitValue"
    />
  </div>
  <HpsfirProDrawer
    v-model:open="visibleAuthQr"
    title="小程序管理员扫码授权"
    width="360px"
    max-width="calc(100vw - 32px)"
    content-class="auth-qr-drawer"
    body-class="auth-qr-drawer__body"
  >
    <div class="qr" :class="qrloading ? 'qr--loading' : ''">
      <QrcodeVue
        :value="qrUrl"
        :size="800"
        style="width: 200px; height: 200px"
      />
      <div class="qr-time">
        过期时间：{{ qrExpiresAt }}
      </div>
      <HpsfirButton @click="() => { visibleAuthQr = false; tableRef?.refresh(); }">已授权完成</HpsfirButton>
    </div>
  </HpsfirProDrawer>
  <HpsfirProForm :is-dialog="true" ref="setTplFormRef" title="选用模板" :items="setTplItems" @ok="handleSetTplOk"/>
  <publish ref="publishRef" @close="() => tableRef?.refresh()"/>
  <HpsfirProDangerDialog
    ref="undoAuditDialogRef"
    title="撤回审核"
    opt-name="撤回"
    :on-ok="handleUndoAuditAction"
    :format-dangder-delete-info="formatUndoAuditInfo"
  />
  <HpsfirProDangerDialog
    ref="revertDialogRef"
    title="版本回退"
    opt-name="回退"
    :on-ok="handleRevertAction"
    :format-dangder-delete-info="formatRevertInfo"
  />
  <HpsfirProDrawer
    v-model:open="visibleRevert"
    title="选择回退版本"
    width="80vw"
    max-width="1200px"
    content-class="business-table-drawer"
    body-class="business-table-drawer__body"
  >
    <div v-loading="revertLoading">
      <HpsfirProTable
        v-if="visibleRevert"
        export-file-name="回退版本"
        row-key="app_version"
        :columns="revertColumns"
        :get-data="getRevertData"
        :loading="revertLoading"
        :operates="revertOperates"
        :paginations="{ pageSize: 10 }"
        :hide-add="true"
        :hide-delete="true"
        :hide-edit="true"
      />
      <div v-if="!revertLoading && revertVersionList.length === 0" style="text-align: center; padding: 20px; color: #999;">
        暂无可回退版本
      </div>
    </div>
  </HpsfirProDrawer>
</template>
<script lang="tsx" setup>
/* eslint-disable max-lines */
import {
  useBaseAsync,
  useRoute,
  useRouter,
  useBaseTenantStore,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { getCurrentRootUrl, getCurrentUrl } from '@/utils';
import QrcodeVue from 'qrcode.vue';
import publish from './publish.vue';
import { normalizeBizTableColumns } from '@/utils/tableColumns';


const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const setTplFormRef = ref<any>();
const publishRef = ref<InstanceType<typeof publish>>();
const undoAuditDialogRef = ref<any>();
const revertDialogRef = ref<any>();


const baseTenantStore = useBaseTenantStore();
const addInitValue = {

};
const conditionsInitValue = {
};

const setTplItems = ref<HpsfirProFormItem[]>([]);
const currentWeapp = ref<any>();
let tpls = [] as any[];
const publisStatusOptions = [
  {
    label: '未发布',
    value: undefined,
  },
  {
    label: '需要更新',
    value: 'need_update',
  },
  {
    label: '审核中',
    value: 'review',
  },
  {
    label: '审核失败',
    value: 'review_failure',
  },
  {
    label: '已发布',
    value: 'success',
  },
];

const compactWxColumnWidth = (column: HpsfirProTableColumn): HpsfirProTableColumn => {
  const widthMap: Record<string, number> = {
    name: 120,
    appid: 132,
    secret: 120,
    modelId: 96,
    principalName: 128,
    templateId: 96,
  };
  const width = widthMap[String(column.name)];
  return width ? { ...column, width } : column;
};

// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(async() => {
  const tplRes = await useApi().weappTplApi.listWeappTplByTenantweappTpl({});
  tpls = tplRes.data.data || [];
  const tplOptions = tpls.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));

  setTplItems.value = [
    {
      name: 'templateId',
      label: '模板',
      type: 'select',
      rule: [{ required: true }],
      options: tplOptions,
    },
  ];


  columns.value = normalizeBizTableColumns([

    {
      name: 'remark',
      label: '备注',
      type: 'string',
      isCondition: true,
    },
    {
      name: 'name',
      label: '小程序名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'appid',
      label: 'AppID',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'secret',
      label: 'secret',
      type: 'string',
    },
    {
      name: 'modelId',
      label: 'model_id',
      type: 'string',
    },
    {
      name: 'principalName',
      label: '主体名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
      hideEdit: true,
    },
    {
      name: 'baseSetting',
      label: '基础配置状态',
      type: 'select',
      options: [
        {
          label: '完成',
          value: true,
        },
        {
          label: '未完成',
          value: false,
        },
      ],
      hideCreate: true,
      hideEdit: true,
      manualRefresh: (row) => {
        row.baseSetting = '加载中...';
        useApi()
          .weappApi.checkBaseSettingweapp({
            appid: row.appid,
          })
          .then((statusRes) => {
            row.baseSetting = statusRes.data.data;
            if (!statusRes.data.data) {
              useApi().weappApi.setBaseSettingweapp({
                appid: row.appid,
              }).then(() => {
                ElMessage.success('重新设置成功，请稍后再次刷新状态');
              });
            }
          })
          .catch(() => {
            row.baseSetting = false;
          });
      },
    },
    {
      name: 'templateId',
      label: '模板',
      type: 'select',
      rule: [{ required: true }],
      options: tplOptions,
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'status',
      label: '发布状态',
      type: 'select',
      options: publisStatusOptions,
      hideCreate: true,
      hideEdit: true,
      manualRefresh: (row) => {
        row.status = '加载中...';
        useApi()
          .weappApi.checkStatusweapp({
            appid: row.appid,
          })
          .then((statusRes) => {
            row.status = statusRes.data.data;
          })
          .catch(() => {
            row.status = undefined;
          });
      },
    },
    {
      name: 'versionInfo',
      label: '线上版本',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
      manualRefresh: (row) => {
        row.versionInfo = '加载中...';
        useApi()
          .weappApi.getVersionInfoweapp({
            appid: row.appid,
          })
          .then((res) => {
            const info = res.data.data;
            row.versionInfo = info?.releaseInfo?.release_version || '未发布';
          })
          .catch(() => {
            row.versionInfo = '获取失败';
          });
      },
    },

    {
      name: 'createTime',
      label: '授权时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : ''),
    },

  ]).map(compactWxColumnWidth);
});

const qrUrl = ref('');
const qrExpiresAt = ref('');
const visibleAuthQr = ref(false);
const qrloading = ref(false);

const visibleRevert = ref(false);
const revertLoading = ref(false);
const revertVersionList = ref<any[]>([]);
const currentRevertWeapp = ref<any>();
const revertColumns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([
  {
    name: 'app_version',
    label: '版本号',
    type: 'string',
  },
  {
    name: 'user_version',
    label: '用户版本',
    type: 'string',
  },
  {
    name: 'user_desc',
    label: '版本描述',
    type: 'string',
  },
]));

const getRevertData = useBaseAsync<HpsfirProTableGetDataFunction>((filter: HpsfirProTableFilter) => {
  const page = filter.paginations.page || 1;
  const pageSize = filter.paginations.pageSize || 10;
  const start = (page - 1) * pageSize;
  return {
    total: revertVersionList.value.length,
    data: revertVersionList.value.slice(start, start + pageSize),
  } as HpsfirProTableData;
});


const topOperates: any[] = [
  {
    key: 'jumpAdd',
    name: '授权微信小程序',
    handler: async() => {
      visibleAuthQr.value = true;
      qrloading.value = true;
      try {
        const res = await useApi().weappApi.getWeappAuthUrlweapp({
          redirectUri: encodeURIComponent(`${getCurrentRootUrl()}${
            baseTenantStore.tenantInfo?.id ? `/___tenant_${baseTenantStore.tenantInfo?.id}` : ''
          }/auth?type=2`),
        });
        qrUrl.value = res.data.data?.url;
        qrExpiresAt.value = res.data.data?.expiresAt;
      } finally {
        qrloading.value = false;
      }
    },
  },
];
const operates: any[] = [

  {
    key: 'setTpl',
    name: '选用模板',
    handler: (row: any) => {
      currentWeapp.value = row;
      setTplFormRef.value?.setOneFormState('templateId', row.templateId || undefined);
      setTplFormRef.value?.showDialog();
      console.log(row);
    },
  },
  {
    key: 'publish',
    name: '配置发布',
    handler: (row: any) => {
      const tpl = tpls.find((item) => item.id === row.templateId);
      if (!tpl) {
        ElMessage.error('请选用模板后再配置发布');
        return;
      }
      if (row.baseSetting !== true) {
        ElMessage.error('请刷新基础配置状态，待完成后可配置发布');
        return;
      }


      publishRef.value?.show({ ...row }, { ...tpl });
    },
  },
  {
    key: 'undoAudit',
    name: '撤回审核',
    handler: (row: any) => {
      undoAuditDialogRef.value?.showDialog(row);
    },
  },
  {
    key: 'revertVersion',
    name: '版本回退',
    handler: async(row: any) => {
      currentRevertWeapp.value = row;
      visibleRevert.value = true;
      revertLoading.value = true;
      revertVersionList.value = [];
      try {
        const res = await useApi().weappApi.getRevertVersionListweapp({ appid: row.appid });
        revertVersionList.value = res.data.data || [];
      } catch (err: any) {
        ElMessage.error(err?.message || '获取可回退版本失败');
      } finally {
        revertLoading.value = false;
      }
    },
  },
];

const loading = ref(false);


const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().weappApi.pageWeappweapp({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data?.map((item: any) => ({
        ...item,
        localtionInterface: item.privacyInterface?.find((inf: any) => inf.name === 'wx.getLocation')?.status || 0,
        hideOp: {
          undoAudit: item.status !== 'review',
          revertVersion: !['review_failure', 'success'].includes(item.status),
        },
      })) || [],
    };

    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;
const formatUndoAuditInfo = (row: any) => `您正在进行撤回审核(${row?.name || row?.appid})操作，请谨慎操作`;
const formatRevertInfo = (row: any) => `您正在进行版本回退(${row?.user_version || row?.app_version})操作，请谨慎操作`;


const updateFun = useBaseAsync(async(data: any) => {
  await useApi().weappApi.updateWeappweapp({
    weappAdminVo: data,
  });
  ElMessage.success('修改成功');
});


const handleSetTplOk = useBaseAsync(async(data: any) => {
  await useApi().weappApi.updateWeappweapp({
    weappAdminVo: {
      ...currentWeapp.value,
      templateId: data.templateId,
    },
  });
  ElMessage.success('设置成功');
  tableRef.value?.refresh();
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().weappApi.delWeappweapp(data.appid);
  ElMessage.success('删除成功');
});

const handleUndoAuditAction = useBaseAsync(async(row: any) => {
  await useApi().weappApi.undoAuditweapp({ appid: row.appid });
  ElMessage.success('撤回审核成功');
  tableRef.value?.refresh();
});

const handleRevertAction = useBaseAsync(async(version: any) => {
  await useApi().weappApi.revertCodeReleaseweapp({
    appid: currentRevertWeapp.value.appid,
    appVersion: version.app_version,
  });
  ElMessage.success('版本回退成功');
  visibleRevert.value = false;
  tableRef.value?.refresh();
});

function handleRevert(version: any) {
  revertDialogRef.value?.showDialog(version);
}

const revertOperates: any[] = [
  {
    key: 'revert',
    name: '回退',
    handler: (row: any) => handleRevert(row),
  },
];

init();


</script>
<style lang="scss" scoped>
.qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;

  &--loading {
    opacity: 0.72;
  }

  &-time {
    font-size: 16px;
    font-weight: 700;
  }
}

:global(.auth-qr-drawer__body) {
  padding: 16px !important;
}

@media (max-width: 767px) {
  :global(.auth-qr-drawer) {
    width: 100vw !important;
    max-width: 100vw !important;
  }
}
</style>
